import { DatabaseRecord } from "../repos/table.repo";

export interface TransactionModel extends DatabaseRecord {
    waterFactoryId: string;
    objectType: string;
    recordId: string;
    amount: number;
    currentBalance: number;
    information: string;
    createdBy: string;
    beneficiaryName: string;
    extraID: string;
    extraType: string;
    paymentMethod?: string;
    createdAt: string;
    updatedAt?: string;
    status?: string;
    actualReceivedDate?: string;
}

export class TransactionModelFactory {
    static getEmpty(): TransactionModel {
        return {
            id: "",
            waterFactoryId: "",
            objectType: "",
            recordId: "",
            amount: 0,
            currentBalance: 0,
            information: "",
            createdBy: "",
            beneficiaryName: "",
            extraID: "",
            extraType: "",
            createdAt: "",
            updatedAt: undefined,
            status: undefined,
            actualReceivedDate: undefined
        };
    }
}
